import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getSupportContact, whatsAppUrl } from '../../lib/support/supportContact';
import styles from './SupportContactCard.module.css';

/**
 * AB#2133 — pilot support path. Shows the founder-configured contact (email
 * and/or WhatsApp) or, when nothing is configured, an honest "being set up"
 * note. Never a hard-coded address and never a 24-hour availability promise.
 */
const SupportContactCard: React.FC = () => {
    const { t } = useLanguage();
    const { email, whatsApp } = getSupportContact();
    const hasContact = Boolean(email || whatsApp);

    return (
        <section className={styles.card} aria-labelledby="support-contact-title" data-testid="support-contact-card">
            <h2 id="support-contact-title" className={styles.title}>
                {t('support.contact.title')}
            </h2>
            {email && (
                <a className={styles.row} href={`mailto:${email}`} data-testid="support-contact-email">
                    <span className={styles.label}>{t('support.contact.emailUs')}</span>
                    <span className={styles.value} dir="ltr">
                        {email}
                    </span>
                </a>
            )}
            {whatsApp && (
                <a
                    className={styles.row}
                    href={whatsAppUrl(whatsApp)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="support-contact-whatsapp"
                >
                    <span className={styles.label}>{t('support.contact.whatsappUs')}</span>
                    <span className={styles.value} dir="ltr">
                        {`+${whatsApp}`}
                    </span>
                </a>
            )}
            {!hasContact && <p className={styles.fallback}>{t('support.contact.notConfigured')}</p>}
        </section>
    );
};

export default SupportContactCard;
